import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const ProjectCard = (props, context) => {
  const { project, index = 0 } = props;
  const { theme: { colorPrimary } } = context;

  const accent = colorPrimary || '#dc2626';

  // Hex-alpha variants (themes provide 6-digit hex colors). Passed as CSS
  // custom properties so the SCSS hover glow / fallback tint follow the theme.
  const cssVars = {
    '--accent': accent,
    '--accent-soft': `${accent}66`,    // ~40% — tag border
    '--accent-border': `${accent}28`,  // ~16% — resting card border
    '--accent-glow-1': `${accent}4d`,  // ~30% — hover glow inner
    '--accent-glow-2': `${accent}1f`,  // ~12% — hover glow outer
    '--accent-tint': `${accent}52`,    // ~32% — fallback gradient
    '--reveal-delay': `${index * 0.1}s`,
  };

  return (
    <div className="project-card reveal" style={cssVars}>
      <div className="project-card__media">
        {project.image ? (
          <img src={project.image} alt={`${project.name} screenshot`} loading="lazy" />
        ) : (
          <div className="project-card__fallback">
            <span className="project-card__glyph">{project.fallback.glyph}</span>
            <span className="project-card__fallback-name">{project.name}</span>
          </div>
        )}
      </div>

      <div className="project-card__body">
        <h3 className="project-card__title">{project.name}</h3>
        <p className="project-card__desc">{project.description}</p>
        <div className="project-card__tags">
          {project.tags.map((tag) => (
            <span key={tag} className="project-card__tag" style={{ color: accent }}>
              {tag}
            </span>
          ))}
        </div>
      </div>

      <div className="project-card__links">
        <a target="_blank" rel="noopener noreferrer" href={project.github}>GitHub</a>
        {project.live && (
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={project.live}
            style={{ color: accent }}
          >
            Live ↗
          </a>
        )}
      </div>
    </div>
  );
};

ProjectCard.propTypes = {
  project: PropTypes.object.isRequired,
  index: PropTypes.number,
};

ProjectCard.contextTypes = {
  theme: PropTypes.any,
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/ProjectCard/ProjectCard.js